// Mesmas regras do app-config do OHIF (scripts/viewer/app-config.lauduz.js) e do proxy da D4.
const REGEX_ID_ATENDIMENTO = /^[0-9]{1,18}$/
const REGEX_UID_DICOM = /^[0-9]+(\.[0-9]+)*$/
const TAMANHO_MAXIMO_UID = 64

export const ehIdAtendimento = (valor: string): boolean => REGEX_ID_ATENDIMENTO.test(valor)

export const ehUidDicom = (valor: string): boolean =>
  valor.length <= TAMANHO_MAXIMO_UID && REGEX_UID_DICOM.test(valor)

/** URL do viewer só com o estudo e o atendimento; `null` se algum dos dois for inválido. */
export const montarUrlViewer = (idAtendimento: number, studyInstanceUid: string): string | null => {
  const id = String(idAtendimento)
  if (!ehIdAtendimento(id) || !ehUidDicom(studyInstanceUid)) return null
  const parametros = new URLSearchParams({ StudyInstanceUIDs: studyInstanceUid, atendimento: id })
  return `/viewer/viewer?${parametros.toString()}`
}
